import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePostPrograde = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const {idx} = useParams()

	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const request = (accountIdx) => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/event/${idx}/account/${accountIdx}/pro-grade`

		fetchRequest('POST', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx를 확인해 주세요.')
				if (fetchResult?.data?.error_code === 'account_idx')
					setAlert('사용자 idx를 확인해 주세요.')
				if (fetchResult?.data?.error_code === 1)
					setAlert('사용자의 현재 프로 자격이 적절치 않습니다.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				else if (fetchResult?.data?.error_code === 2)
					setAlert('사용자 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePostPrograde
